import React, { memo } from "react";

import SkeletonPlaceholder from "@/components/molecules/SkeletonPlaceholder";

import { Box } from "@/components/atoms/Box";
import { Stack } from "@/components/atoms/Stack";

/**
 * Props for SkeletonPlayerView component
 */
interface Props {
  bgColor: string;
}

/**
 * Pure view component for player skeleton
 * @param root0 - Component props
 * @param root0.bgColor - Background color value
 */
const SkeletonPlayerView = ({ bgColor }: Props) => (
  <SkeletonPlaceholder>
    <Stack direction="horizontal" className="min-h-20 items-center gap-4 py-2">
      <Stack className="flex-1 gap-2">
        <Box
          className={`h-8 w-full animate-pulse rounded-none opacity-70 ${bgColor}`}
        />
        <Box
          className={`h-7 w-3/4 animate-pulse rounded-none opacity-70 ${bgColor}`}
        />
      </Stack>
      <Box
        className={`h-7 w-14 animate-pulse rounded-none opacity-70 ${bgColor}`}
      />
    </Stack>
  </SkeletonPlaceholder>
);

SkeletonPlayerView.displayName = "SkeletonPlayerView";

export default memo(SkeletonPlayerView);
